<template>
  <div class="collage-carousel">
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="collage-item"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>

    <!-- Modal teletransportado al body -->
    <Teleport to="body">
      <div
        v-if="isImageEnlarged"
        class="image-modal"
        @click="closeModal"
      >
        <img
          :src="images[currentIndex]"
          class="enlarged-image"
          alt="Imagen ampliada"
        />
      </div>
    </Teleport>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'CollageAnimado',
  setup() {
    const images = [
      require('@/assets/31003_11zon.webp'),
      require('@/assets/31009_11zon.webp')
    ]

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    return {
      images,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0;
  contain: content; /* Optimización de pintado */
}

.collage-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 0;
}

.collage-item {
  grid-column: span 12;
  cursor: pointer;
  
  /* Animación rápida CSS: Garantiza visibilidad inmediata en GPU */
  animation: entradaAcelerada 0.3s ease-out forwards;
  will-change: transform, opacity;
  backface-visibility: hidden;
}

.collage-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 0;
  display: block;
  box-shadow: none;
  content-visibility: auto;
}

/* Animación ultraligera impulsada por hardware */
@keyframes entradaAcelerada {
  0% {
    opacity: 0;
    transform: translate3d(0, 10px, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

/* Modal */
.image-modal {
  position: fixed;
  inset: 0;
  background-color: rgba(10, 10, 10, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 12px;
  object-fit: contain;
}
</style>